import { Tag } from '../Filters/TagFilterBar/types'

export const getWhitelistedTags = (
  whitelist: string[] = [],
  tags: Tag[] = [],
) => {
  if (!whitelist.length || !tags.length) {
    return []
  }

  const normalise = (tag: string) => tag?.toLowerCase().trim()
  return whitelist.reduce<Tag[]>((prev, tag) => {
    const normalisedWhitelistTag = normalise(tag)
    const foundTag = tags.find(
      (t) => normalise(t.value) === normalisedWhitelistTag,
    )

    if (!foundTag) {
      return prev
    }

    return [...prev, foundTag]
  }, [])
}
